import type JCE from '@chesscom/js-chess-engine';
import type { API } from 'chessboard/api/config/types';
import type { MetaGameTerminationValues } from './get-position-info';

/**
 * creates the getFinalPositionInfo method
 */
export function createGetFinalPositionInfo(context: API.Context) {
  /**
   * Returns game state information about the final position in the main line:
   *
   * @example
   *
   * {
   *   gameOver: true,
   *   check: true,
   *   checkmate: true,
   *   draw: false,
   *   stalemate: false,
   *   threefold: false,
   *   insufficient: false,
   *   fiftyMoveRule: false,
   *   isValid: true
   * }
   */
  return function getFinalPositionInfo(
    metaGameTerminationValues?: MetaGameTerminationValues,
  ): false | JCE.Position.Info {
    const { api } = context;

    const mainLine = api.getLine(0);
    const { startingFen } = api.getFingerprints();

    return api.getPositionInfo(mainLine, startingFen, metaGameTerminationValues);
  };
}
